import { useAlertStats } from '../../hooks/useAlertStats';
import clsx from 'clsx';

interface AlertBadgeProps {
  className?: string;
}

export default function AlertBadge({ className }: AlertBadgeProps) {
  const { data: stats } = useAlertStats();

  if (!stats) {
    return null;
  }

  // Count only unacknowledged active alerts
  const unacknowledgedCount = stats.total_active - stats.total_acknowledged;

  if (unacknowledgedCount === 0) {
    return null;
  }

  const hasCritical = (stats.by_severity?.critical || 0) > 0;

  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5',
        'text-xs font-semibold rounded-full',
        hasCritical ? 'bg-red-600 text-white' : 'bg-yellow-600 text-white',
        className
      )}
    >
      {unacknowledgedCount}
    </span>
  );
}
